<template>

  <div class="dynamic-content">
    <div ref="textContent" v-if="content === 'content_1'">
      <div v-if="eventData && eventData.gpt_output">
        {{ eventData.gpt_output }}
      </div>
      </div>
    <div ref="textContent" v-else-if="content === 'content_4'">
      <h3>Most Popular Bets</h3>
       <StatsTable :csvData=eventData.data_stats.most_popular_bets  />
        <h3>Head to Head</h3>
       <StatsTable :csvData=eventData.data_stats.h2h  />
        <h3>Latest matches</h3>
           <StatsTable :csvData=eventData.data_stats.last_played_matches  />
      <div class="explanation">
          - Date = Match Date (dd/mm/yy)<br>
          - Home Team = Home Team<br>
          - Away Team = Away Team<br>
          - FTHG = Full Time Home Team Goals<br>
          - FTAG = Full Time Away Team Goals<br>
          - FTR and Res = Full Time Result (H=Home Win, D=Draw, A=Away Win)<br>
          - HTHG = Half Time Home Team Goals<br>
          - HTAG = Half Time Away Team Goals<br>
          - HTR = Half Time Result (H=Home Win, D=Draw, A=Away Win)<br>
          - HS = Home Team Shots<br>
          - AS = Away Team Shots<br>
          - HST = Home Team Shots on Target<br>
          - AST = Away Team Shots on Target<br>
          - HC = Home Team Corners<br>
          - AC = Away Team Corners<br>
          - HF = Home Team Fouls Committed<br>
          - AF = Away Team Fouls Committed<br>
          - HY = Home Team Yellow Cards<br>
          - AY = Away Team Yellow Cards<br>
          - HR = Home Team Red Cards<br>
          - AR = Away Team Red Cards
        </div>
        <h3>League Table</h3>
        <StatsTable :csvData=eventData.data_stats.league_table  />
        <div class="explanation">
          - Team = Team name<br>
          - MP = Total matches played in current season<br>
          - W = Number of wins<br>
          - D = Number of draws<br>
          - L = Number of losses<br>
          - GF = Goals scored<br>
          - GA = Goals conceded<br>
          - GD = Goals difference<br>
          - PTS = Points
        </div>
        <h3>Players stats</h3>
        <StatsTable :csvData=eventData.data_stats.players_stats  />
        <div class="explanation">
          - PN = Player's name<br>
          - is_home_team = Does player belong to home team<br>
          - G = Goals for current season<br>
          - A = Assists for current season<br>
          - YRD = Yellow-Red cards for current season<br>
          - YC = Yellow cards for current season<br>
          - RC = Red cards for current season
        </div>
    </div>
     <div ref="textContent" v-else-if="content === 'content_2'">
      <div>{{dataSubstring}}</div>
    </div>
    <div ref="textContent" v-else-if="content === 'content_11'">
      <div>{{eventData.data_1x2}}</div>
    </div>
    <div ref="textContent" v-else-if="content === 'content_3'">{{ eventData.full_prompt }}</div>
    <div ref="textContent" v-else-if="content === 'content_5'">
      <div class="agents-container">
        <div v-for="(agent, name) in agentsData.agents" :key="name" class="agent-card">
          <h2>{{ name }}</h2>
          <p><strong>Role:</strong> {{ agent.role }}</p>
          <p><strong>Goal:</strong> {{ agent.goal }}</p>
          <p><strong>Backstory:</strong> {{ agent.backstory }}</p>
        </div>
      </div>
    </div>
     <div ref="textContent" v-else-if="content === 'content_6'">
      <div class="agents-container">
        <div v-for="(task, name) in agentsData.tasks" :key="name" class="agent-card">
          <h2>{{ task.name }}</h2>
          <p><strong>Description:</strong> {{ task.description }}</p>
          <p><strong>Expected Output:</strong> {{ task.expected_output }}</p>
          <p><strong>Agent:</strong> {{ task.agent }}</p>
        </div>
      </div>
    </div>
      <div class="workflow-container" ref="textContent" v-else-if="content === 'content_7'">
     <h1>Workflow Visualization</h1>
        <div>
          <div v-for="(step, index) in agentsData.workflow" :key="index">
            <div class="task-box">
              <h3>{{ step.task_name }}</h3>
              <p><strong>Agent:</strong> {{ step.agent_name }}</p>
            </div>
            <div v-if="index < agentsData.workflow.length - 1" class="arrow-container">
              <div class="arrow"></div>
            </div>
          </div>
        </div>
      </div>
    <div ref="textContent" v-else-if="content === 'content_8'">
        <div class="token-summary">
        <h2>Token Usage Summary</h2>
        <p>Model: {{ modelName }}</p>
        <p>Input Tokens: {{ eventData.token_usage.input }} (Cost: ${{inputCost}}) (${{inputCostPerMillion}} per 1_000_000 tokens)</p>
        <p>Output Tokens: {{ eventData.token_usage.output }} (Cost: ${{outputCost}})  (${{outputCostPerMillion}} per 1_000_000 tokens)</p>
        <p>Total Tokens: {{ eventData.token_usage.total }} (Total Cost: ${{ parseFloat(inputCost) + parseFloat(outputCost)}})</p>
      </div>
      <div>{{eventData.tasks_output}}</div>
    </div>
    <div ref="textContent" v-else-if="content === 'content_9'">
      <div v-if="eventData && eventData.agents_output">
        {{ eventData.agents_output }}
      </div>
    </div>
    <div ref="textContent" v-else-if="content === 'content_10'">
      <EventsList/>
    </div>
    <div>
      <p v-if="eventData && eventData.gpt_output_generated_at && ['content_1', 'content_9'].includes(content)"><strong>Generated at:</strong>
        {{ formatTimestamp(eventData.gpt_output_generated_at) }}</p>
      <div v-if="['content_1', 'content_2', 'content_3', 'content_9', 'content_11'].includes(content)">
        <button @click="copyToClipboard" class="copy-button">{{ buttonLabel }}</button>
      </div>
      <div v-if="['content_1', 'content_9'].includes(content)">
          <button @click="generateOutput(content === 'content_1' ? 'force_mono' : 'force_agents')"
                class="copy-button">{{ generateButtonLabel }}</button></div>
      </div>
    </div>
</template>

<script>
import StatsTable from "@/components/StatsTable.vue";
import EventsList from "@/components/EventsList.vue";
// import WorkflowDiagram from "@/components/WorkflowDiagram.vue";

export default {
  components: {StatsTable, EventsList},
  props: {
    content: {
      type: String, // Define the expected type, e.g., String, Number, Array, etc.
      default: 'content_1'   // Optional: provide a default value if none is passed
    }
  },
  data() {
  return {
   buttonLabel: 'Copy to clipboard', // New data to control the button's label
    isButtonActive: true, // New data to control the button's active state
    modelName: "GPT-4o-mini", // Model name for pricing reference
    inputCostPerMillion: 0.15, // Cost per million input tokens
    outputCostPerMillion: 0.60, // Cost per million output tokens
    generateButtonLabel: 'Generate', // Button label for generating output
    generateButtonActive: true, // Button active state for generating output
  };
},
   computed: {
    eventData() {
      return this.$store.state.eventData;
    },
     inputCost() {
      return ((this.eventData.token_usage.input / 1_000_000) * this.inputCostPerMillion).toFixed(4);
     },
      outputCost() {
        return ((this.eventData.token_usage.output / 1_000_000) * this.outputCostPerMillion).toFixed(4);
      },
     agentsData() {
       return this.$store.state.agentsData;
     },
     dataSubstring() {
      const fullPrompt = this.eventData.full_prompt;
      const startIndex = fullPrompt.indexOf('##DATA');
      if (startIndex === -1) return ''; // If '##DATA' is not found, return empty string
      return fullPrompt.substring(startIndex); // Extracts from '##DATA' to the end
  }
  },
    methods: {
    formatTimestamp(timestamp) {
      return new Intl.DateTimeFormat("en-US", {
        dateStyle: "medium",
        timeStyle: "short",
      }).format(new Date(timestamp));
    },
    generateOutput(force_service) {
      if (!this.generateButtonActive) return; // Prevents function execution if the button is inactive
      this.generateButtonLabel = 'Generating...'; // Change button label
      this.generateButtonActive = false; // Disable button
      // Call the API to generate output
      this.$store.dispatch('fetchEventData', {
        eventId: this.$store.state.eventId,
        market: this.$store.state.market,
        apiKey: this.$store.state.apiKey,
        service: this.$store.state.service,
        engine: this.$store.state.engine,
        useAgents: null,
        force_service: force_service,
        dummy: this.$store.state.dummy
      }
      ).then(() => {
        this.generateButtonLabel = 'Generate'; // Reset button label
        this.generateButtonActive = true; // Enable button
      });
    },

    copyToClipboard() {
    if (!this.isButtonActive) return; // Prevents function execution if the button is inactive

    const text = this.$refs.textContent.innerText;

  if (navigator.clipboard && window.isSecureContext) {
    navigator.clipboard.writeText(text).then(() => {
      this.buttonLabel = 'Copied'; // Change button label
      this.isButtonActive = false; // Disable button

      // Reset button after 3 seconds
      setTimeout(() => {
        this.buttonLabel = 'Copy to clipboard';
        this.isButtonActive = true;
      }, 3000);

    }, (err) => {
      console.error('Failed to copy text: ', err);
      this.isButtonActive = true; // Ensure button is active even if copy fails
    });
  } else {
    console.log('navigator.clipboard');
    var textArea = document.createElement("textarea");
    textArea.value = text;
    textArea.style.position = "fixed";  //avoid scrolling to bottom
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
        var successful = document.execCommand('copy');
        var msg = successful ? 'successful' : 'unsuccessful';
        console.info(msg);
    } catch (err) {
        console.warning('Was not possible to copy te text: ', err);
    }
    document.body.removeChild(textArea)
     this.buttonLabel = 'Copied'; // Change button label
      this.isButtonActive = false; // Disable button

      // Reset button after 3 seconds
      setTimeout(() => {
        this.buttonLabel = 'Copy to clipboard';
        this.isButtonActive = true;
      }, 3000);
  }

    }
  }
};
</script>

<style scoped>
.dynamic-content {
  white-space: pre-wrap;
  width: 100%;
  padding-right: 20px;
}

.copy-button {
  padding: 8px 16px; /* Adjust padding to make the button neither too big nor too small */
  background-color: #758da7;
  color: white;
  border: none;
  border-radius: 5px;
  cursor: pointer;
  margin-top: 40px;
  margin-right: 10px;
  margin-left: 20px;
  height: 50px;
  min-width: 120px
}

.copy-button:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}



.copy-button:hover {
  background-color: #0056b3;
}

.explanation {
  font-size: 1em;
  margin-top: 10px;
}

.token-summary {
  border: 1px solid #ccc;
  padding: 16px;
  border-radius: 8px;
  background-color: #f9f9f9;
}
.token-summary h2 {
  margin-bottom: 12px;
}
.token-summary p {
  margin: 4px 0;
}
.workflow-container {
      display: flex;
      flex-direction: column;
      align-items: center;
      text-align: center;
      margin: 20px;
      width: 800px;

    }
    .task-box {
      border: 2px solid #007BFF;
      border-radius: 8px;
      padding: 10px 20px;
      margin: 10px;
      width: 300px;
      background-color: #f0f8ff;
      position: relative;
    }
    .task-box h3 {
      margin: 5px 0;
      font-size: 16px;
      color: #333;
    }
    .task-box p {
      margin: 0;
      font-size: 14px;
      color: #555;
    }
    .arrow {
        width: 0;
        height: 0;
        border-left: 10px solid transparent;
        border-right: 10px solid transparent;
        border-top: 10px solid #007BFF;
        margin: 0 auto; /* Center the arrow horizontally */
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .arrow-container {
        display: flex;
        justify-content: center; /* Ensure arrows are in the middle of the task-box width */
        align-items: center;
        height: 30px; /* Optional, for consistent spacing */
    }
</style>